<template>
  <Row class="management" :gutter="35">
    <i-col :md="12">
      <img src="../../assets/refik_selimi.jpg" alt="Mr.Sc Refik Selimi" />
      <hr />
      <h3>Mr.Sc Refik Selimi</h3>
      <h4>{{$t('chief')}}</h4>
      <p>
        {{moreOrLess($t('management_members.refik_selimi'), full1)}}
        <span class="showmore" @click="full1 = !full1" alt="expand">
          {{ full1 ? $t('less') : $t('more') }}
        </span>
      </p>
    </i-col>
    <i-col :md="12">
      <img src="../../assets/faton_hasolli.jpg" alt="Prof.dr.Afrim Loku" />
      <hr />
      <h3>Mr.Sc Faton Hasolli</h3>
      <h4>{{$t('deputy_chief')}}</h4>
      <p>
        {{moreOrLess($t('management_members.faton_hasolli'), full2)}}
        <span class="showmore" @click="full2 = !full2" alt="expand">
          {{ full2 ? $t('less') : $t('more') }}
        </span>
      </p>
    </i-col>
  </Row>
</template>
<script>
export default {
  methods: {
    moreOrLess(string, trueOrWhat) {
      return string.slice(trueOrWhat ? 0 : 0, trueOrWhat ? string.length : 0);
    },
  },
  data() {
    return {
      full1: false,
      full2: false,
    };
  },
};
</script>
<style lang="scss">
.management {
  img {
    width: 100%;
    min-height: 300px;
    max-height: 400px;
    height: 100%;
    object-fit: fill;
  }
  .showmore {
    color: #10a995;
    cursor: pointer;
  }
}
</style>
